export const Users = [
  {
    id: 1,
    profilePicture: "assets/person/1.jpeg",
    username: "Vince Akkerman",
  },
  {
    id: 2,
    profilePicture: "assets/person/2.jpeg",
    username: "Benjamin Ragsdale",
  },
  {
    id: 3,
    profilePicture: "assets/person/3.jpg",
    username: "Josephine Brooks",
  },
  {
    id: 4,
    profilePicture: "assets/person/4.jpeg",
    username: "Frederick Boyd",
  },
  {
    id: 5,
    profilePicture: "assets/person/5.jpeg",
    username: "Ronnie Myers",
  },
  {
    id: 6,
    profilePicture: "assets/person/6.jpeg",
    username: "Logan Berry",
  },
  {
    id: 7,
    profilePicture: "assets/person/7.jpeg",
    username: "Bertha Stanley",
  },
  {
    id: 8,
    profilePicture: "assets/person/8.jpeg",
    username: "Jenny Nguyen",
  },
  {
    id: 9,
    profilePicture: "assets/person/9.jpeg",
    username: "Tyler West",
  },
  {
    id: 10,
    profilePicture: "assets/person/10.jpeg",
    username: "Melvin Taylor",
  },
  {
    id: 11,
    profilePicture: "assets/person/11.jpeg",
    username: "Kristen Richardson",
  },
  {
    id: 12,
    profilePicture: "assets/person/12.jpeg",
    username: "Austin Rhodes",
  },
  {
    id: 13,
    profilePicture: "assets/person/13.jpeg",
    username: "Ashley Coleman",
  },
  {
    id: 14,
    profilePicture: "assets/person/14.jpeg",
    username: "Gilbert Watts",
  },
  {
    id: 15,
    profilePicture: "assets/person/15.jpeg",
    username: "Annette Kelley",
  },
  {
    id: 16,
    profilePicture: "assets/person/16.jpeg",
    username: "Jean Walker",
  },
  {
    id: 17,
    profilePicture: "assets/person/17.jpeg",
    username: "Calvin Young",
  },
  {
    id: 18,
    profilePicture: "assets/person/18.jpeg",
    username: "Leah Sims",
  },
  {
    id: 19,
    profilePicture: "assets/person/19.jpeg",
    username: "Marian Wells",
  },
  {
    id: 20,
    profilePicture: "assets/person/20.jpeg",
    username: "Marion Stephens",
  },
];

export const Posts = [
  {
    id: 1,
    desc: "Love For All, Hatred For None.",
    photo: "assets/post/1.jpeg",
    date: "5 mins ago",
    userId: 1,
    like: 32,
    comment: 9,
  },
  {
    id: 2,
    desc: "A blazing fire makes flame and brightness out of everything that is thrown into it.",
    photo: "assets/post/2.jpeg",
    date: "15 mins ago",
    userId: 2,
    like: 2,
    comment: 1,
  },
  {
    id: 3,
    desc: "Every moment is a fresh beginning.",
    photo: "assets/post/3.jpeg",
    date: "1 hour ago",
    userId: 3,
    like: 61,
    comment: 2,
  },
  {
    id: 4,
    desc: "If you have always done it that way, it is probably wrong",
    photo: "assets/post/4.jpeg",
    date: "4 hours ago",
    userId: 4,
    like: 7,
    comment: 3,
  },
  {
    id: 5,
    desc: "A man of words and not of deeds is like a garden full of weeds.",
    photo: "assets/post/5.jpeg",
    date: "5 hours ago",
    userId: 5,
    like: 23,
    comment: 5,
  },
  {
    id: 6,
    desc: "People think of education as something they can finish. ",
    photo: "assets/post/6.jpeg",
    date: "1 day ago",
    userId: 6,
    like: 44,
    comment: 6,
  },
  {
    id: 7,
    desc: "Never regret anything that made you smile.",
    photo: "assets/post/7.jpeg",
    date: "2 days ago",
    userId: 7,
    like: 52,
    comment: 3,
  },
  {
    id: 8,
    desc: "Argue for your limitations, and sure enough they’re yours.",
    photo: "assets/post/8.jpeg",
    date: "3 days ago",
    userId: 8,
    like: 15,
    comment: 1,
  },
  {
    id: 9,
    desc: "Change the world by being yourself.",
    photo: "assets/post/9.jpeg",
    date: "5 days ago",
    userId: 9,
    like: 11,
    comment: 2,
  },
  {
    id: 10,
    desc: "Give more./Give what you didn’t get./Love more./Drop the old story. .",
    photo: "assets/post/10.jpeg",
    date: "1 week ago",
    userId: 10,
    like: 104,
    comment: 12,
  },
  {
    id: 11,
    desc: "To forgive is to set a prisoner free and discover that the prisoner was you",
    photo: "assets/post/11.jpeg",
    date: "2 hours ago",
    userId: 11,
    like: 155,
    comment: 11,
  },
  {
    id: 12,
    desc: "Study without desire spoils the memory, and it retains nothing that it takes in.",
    photo: "assets/post/12.jpeg",
    date: "6 hours ago",
    userId: 12,
    like: 77,
    comment: 20,
  },
  {
    id: 13,
    desc: "If you can't do it with feeling - don't. ",
    photo: "assets/post/13.jpeg",
    date: "2 week ago",
    userId: 13,
    like: 104,
    comment: 12,
  },
  {
    id: 14,
    photo: "assets/post/14.jpeg",
    date: "3 days ago",
    userId: 14,
    like: 116,
    comment: 39,
  },
  {
    id: 15,
    desc: "What you are aware of you are in control of. What you are not aware of is in control of you.",
    photo: "assets/post/15.jpeg",
    date: "1 week ago",
    userId: 15,
    like: 111,
    comment: 29,
  },
  {
    id: 16,
    desc: "A man of words and not of deeds is like a garden full of weeds.",
    photo: "assets/post/16.jpeg",
    date: "1 week ago",
    userId: 16,
    like: 116,
    comment: 32,
  },
  {
    id: 17,
    photo: "assets/post/17.jpeg",
    date: "5 hours ago",
    userId: 17,
    like: 330,
    comment: 27,
  },
  {
    id: 18,
    desc: "Why should you feel anger at the world, as if the world would notice?",
    photo: "assets/post/18.jpeg",
    date: "3 hours ago",
    userId: 18,
    like: 39,
    comment: 10,
  },
  {
    id: 19,
    desc: "The most effective form of learning is practice, not planning. ",
    photo: "assets/post/19.jpeg",
    date: "3 week ago",
    userId: 10,
    like: 104,
    comment: 12,
  },
  {
    id: 20,
    desc: "I cannot judge what he did, because I did not have his information..",
    photo: "assets/post/20.jpeg",
    date: "49 min ago",
    userId: 20,
    like: 143,
    comment: 53,
  },
];
